import { BaseIcon } from './BaseIcon';

const HomeIcon = (props) => {
  return (
    <BaseIcon {...props}>
      <path
        d="M18.9998 7.90625V17.9999C18.9998 19.1045 18.1043 19.9999 16.9998 19.9999H6.99976C5.89519 19.9999 4.99976 19.1045 4.99976 17.9999V7.90625M1.99976 10L10.8528 3.80285C11.5415 3.3208 12.458 3.3208 13.1467 3.80285L21.9998 10"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default HomeIcon;
